import { useState } from 'react';
import { Share2, Facebook, MessageCircle, Copy, Check } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { ShareDialog } from '@/components/share/ShareDialog';
import { buildChannelHref, buildShareUrl, defaultShareText } from '@/lib/share';
import { toast } from 'sonner';

export function FooterShareBlock() {
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);

  const url = typeof window !== 'undefined' ? window.location.href : 'https://minnyeelbil.dk';
  const title = typeof document !== 'undefined' ? document.title : 'Min Nye Elbil';
  const text = defaultShareText('generic', 'Min Nye Elbil — danmarks nye elbil-oversigt');

  const openChannel = (channel: 'facebook' | 'messenger' | 'whatsapp') => {
    const channelUrl = buildShareUrl(url, channel);
    const href = buildChannelHref(channel, { title, text, url: channelUrl });
    window.open(href, '_blank', 'noopener,noreferrer');
  };

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(buildShareUrl(url, 'copy'));
      setCopied(true);
      toast.success('Link kopieret');
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error('Kunne ikke kopiere linket');
    }
  };

  return (
    <>
      <div className="border-t border-primary-foreground/10 mt-6 pt-6">
        <div className="max-w-2xl mx-auto text-center">
          <h4 className="font-semibold mb-1 flex items-center justify-center gap-2">
            <Share2 className="w-4 h-4 text-accent" /> Hjælp os med at vokse
          </h4>
          <p className="text-sm text-primary-foreground/70 mb-3">
            Min Nye Elbil er gratis og helt nyt. Del siden med venner og familie der overvejer en elbil — det betyder alt for os.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-2">
            <Button size="sm" variant="accent" className="gap-2" onClick={() => openChannel('facebook')}>
              <Facebook className="w-4 h-4" /> Facebook
            </Button>
            <Button size="sm" variant="accent" className="gap-2" onClick={() => openChannel('messenger')}>
              <MessageCircle className="w-4 h-4" /> Messenger
            </Button>
            <Button size="sm" variant="accent" className="gap-2" onClick={() => openChannel('whatsapp')}>
              <MessageCircle className="w-4 h-4" /> WhatsApp
            </Button>
            <Button size="sm" variant="outline" className="gap-2 bg-transparent text-primary-foreground border-primary-foreground/30 hover:bg-primary-foreground/10 hover:text-primary-foreground" onClick={copy}>
              {copied ? <Check className="w-4 h-4" /> : <Copy className="w-4 h-4" />}
              {copied ? 'Kopieret' : 'Kopier link'}
            </Button>
            <Button size="sm" variant="outline" className="gap-2 bg-transparent text-primary-foreground border-primary-foreground/30 hover:bg-primary-foreground/10 hover:text-primary-foreground" onClick={() => setOpen(true)}>
              <Share2 className="w-4 h-4" /> Flere muligheder
            </Button>
          </div>
        </div>
      </div>
      <ShareDialog open={open} onOpenChange={setOpen} title={title} url={url} context="generic" />
    </>
  );
}
